import React from 'react';
import { StethoscopeIcon, SyringeIcon, HospitalIcon, GiftIcon, RefreshCwIcon } from 'lucide-react';
const POINTS = [{
  icon: StethoscopeIcon,
  title: 'Professional clinical assessment references',
  body: 'Access anatomical diagrams, assessment frameworks, monitoring charts, neurological references, and clinical deterioration recognition tools.'
}, {
  icon: SyringeIcon,
  title: 'Structured clinical procedure references',
  body: 'Review injection procedures, vascular access devices, wound assessment, medication verification, and bedside equipment through organized visual resources.'
}, {
  icon: HospitalIcon,
  title: '6 specialized nursing clinical areas',
  body: 'Patient assessment, IV therapy, wound care, medication safety, bedside procedures, and emergency nursing—all organized into one professional system.'
}, {
  icon: GiftIcon,
  title: '5 practical nursing bonuses',
  body: 'Documentation templates, patient safety checklists, medication calculation worksheets, clinical scenarios, and shift organization tools.'
}, {
  icon: RefreshCwIcon,
  title: 'Ready to reference again and again',
  body: 'Return to the system whenever you need to review a clinical assessment, compare equipment, recognize a complication, verify a safety workflow, or organize nursing documentation.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-109" data-mp="2xq646g40yzlm">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-110" data-mp="2xntm82y9op8k">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-111" data-mp="2sruss0y30h1a">
          THIS ISN'T JUST ANOTHER NURSING EBOOK
        </h2>
        <p className="mt-1 text-center font-display text-sm font-bold uppercase leading-tight text-tech-light sm:text-xl" data-id="element-112" data-mp="2ntt8jcox6bo8">
          IT'S A COMPLETE, READY-TO-USE VISUAL NURSING REFERENCE SYSTEM.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-113" data-mp="1ca8gbxlu3qz3">
          {POINTS.map((point, i) => {
          const Icon = point.icon;
          return <div key={point.title} className={`flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3 ${i === POINTS.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-114" data-mp="19sogffkwjxw0" data-mpi={i}>
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech-light" aria-hidden="true" data-id="element-115" data-mp="14sscthg4a8gz" />
                <div data-id="element-116" data-mp="r1nimuviq8e1">
                  <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-117" data-mp="r1dsn7ah418c">{point.title}</h3>
                  <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-118" data-mp="vsm2u5jmnqmk">{point.body}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-white sm:text-lg" data-id="element-119" data-mp="m2kfjfz3mc8p">
          Less scattered searching. Clearer clinical references.{' '}
          <span className="text-tech-light" data-id="element-120" data-mp="84w5l36kkpif">More organized nursing resources.</span>
        </p>
      </div>
    </section>;
}